import { LoaderFunctionArgs } from "react-router"
import { handleApiFetch } from "../../utils"
import { useEnvironment } from "../../context/useEnv"

export async function dashboardLoader({ request, context: loaderContext }: LoaderFunctionArgs<any>) {
    let context = loaderContext;
    if (typeof window !== "undefined" && window.__client_context) {
        context = window.__client_context
    }

    const env = context["env"]
    const fetchPromises = Promise.allSettled([
        handleApiFetch(env, `/wiki/articles/latest`),
        handleApiFetch(env, `/wiki/articles/drafts`, null, context["info"]),
        handleApiFetch(env, `/wiki/articles?category_id=1`, null, context["info"]),
        handleApiFetch(env, `/wiki/categories`)
    ])

    // Wait for the API fetchs if loading from the server
    if (typeof window == "undefined") {
        const [articles, drafts, guides, tags] = await fetchPromises;

        return {
            data: [articles, drafts, guides, tags]
        }
    }

    // Return the promises if loading from the client
    return {
        promises: fetchPromises
    }
}